module.exports = __webpack_public_path__ + "img/reprint.0d247e92.svg";